var timelineData = {
  name: 'timeline',
  data: [{
    fontSize: 12,
    lineHeight: 20
  }]
};
export default timelineData;